export default {
    supplierName: "ဆိုင်နာမည်",
    mainCategory: "လုပ်ငန်းအမျိုးအစား",
    contactName: "ဆက်သွယ်ရန်အမည်",
    contactPhoneNumber: "ဆက်သွယ်ရန်ဖုန်းနံပါတ်",
    warehouseAddr: "ဂိုဒေါင် Addr",
    setPassword: "စကားဝှက်သတ်မှတ်ပါ။",
    confirmPassword: "စကားဝှက်အတည်ပြုခြင်း",
    legalPersonsname: "တရားဝင်ပုဂ္ဂိုလ်များအမည်",
    legalPersonPhoneNumber: "တရားဝင်ပုဂ္ဂိုလ်ဖုန်းနံပါတ်",
    legalPersonsIDCard: "တရားဝင်လူများ ID ကတ်",
    IDPhoto: "အိုင်ဒီဓာတ်ပုံ",
    whetherThreeCertificatesAreInOne: "လက်မှတ်သုံးခု တစ်ခုတည်းမှာလား။",
    unifiedSocialCreditCode: "ပေါင်းစည်းထားသော လူမှုခရက်ဒစ်ကုဒ်",
    operatingPeriod: "လည်ပတ်ကာလ",
    businessLicense: "လုပ်ငန်းလိုင်စင်",
    long: "ရှည်သည်။"
}